/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import invariant from 'invariant';
import SmartTable from 'components/SmartTable.jsx';
import SchoolTableBodyContainer from 'admin/containers/SchoolTableBodyContainer.jsx';
import DistrictStatistics from 'admin/components/DistrictStatistics.jsx';
import AdminBillingBanner from 'admin/components/AdminBillingBanner.jsx';

type Props = {
  params: Object,
  organization?: { paid: boolean },
}

const nameSorts = [
  { key: 'name_asc', name: 'Ascending' },
  { key: 'name_desc', name: 'Descending' },
];

const COLUMNS = [
  { key: 'name', name: 'School', sorts: nameSorts },
  { key: 'teacher_count', name: 'Teachers' },
  { key: 'parent_count', name: 'Parents' },
  { key: 'class_count', name: 'Classes' },
  { key: 'message_count', name: 'Announcements' },
];

function AdminSchools(props: Props) {
  const { districtId } = props.params;
  invariant(districtId, 'district id missing in router param');
  const namespace = `admin-school-table-${props.params.districtId}`;

  return (
    <div>
      <DistrictStatistics organizationId={districtId} />
      <SmartTable namespace={namespace} columns={COLUMNS} initialSort="name_asc">
        {({ sort }) => (
          <SchoolTableBodyContainer
            disabled={!props.organization || !props.organization.paid}
            districtId={districtId}
            sort={sort}
          />
        )}
      </SmartTable>
      <AdminBillingBanner />
    </div>
  );
}

const withOrganization = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      paid
    }
  }`,
  {
    options: ({ params }) => ({ variables: { organizationId: [params.districtId] } }),
    props: ({ data }) => ({ organization: data.organizations ? data.organizations[0] : null }),
  }
);

export { AdminSchools };
export default withOrganization(AdminSchools);



// WEBPACK FOOTER //
// ./src/admin/components/AdminSchools.jsx